import { render, staticRenderFns } from "./BillingContainer.vue?vue&type=template&id=2a4c4e40&scoped=true"
import script from "./BillingContainer.vue?vue&type=script&lang=js"
export * from "./BillingContainer.vue?vue&type=script&lang=js"
import style0 from "./BillingContainer.vue?vue&type=style&index=0&id=2a4c4e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4c4e40",
  null
  
)

export default component.exports